import firebase from 'firebase/compat/app';

export const getBdgValues = (id) => {
    const db = firebase.firestore();

    return db.collection('bdgs').doc(id).get();
};

export default getBdgValues;
